<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title style="color: #1C2546; margin-top: 40px"
        >Solicitudes Comprobantes</v-toolbar-title
      >
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-divider></v-divider>
    </v-toolbar>
    <v-alert
              type="success"
              :value="alert"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Solicitud editada con exito.</v-alert
            >
    <v-alert
              type="error"
              :value="alert9"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >{{ errorMsg }}</v-alert
            >  
    <v-tabs fixed-tabs>
      <v-tab>Individuales</v-tab>
      <v-tab>Grupos</v-tab>
      <v-tab-item>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="solicitudes"
          :search="search"
          item-key="id_solicitud"
          sort-by="fecha"
          show-select
          class="elevation-1"
        >
          <template v-slot:top>
            <v-dialog v-model="dialog" max-width="75%">
              <v-card>
                <v-card-title
                  ><span class="headline">Editar Solicitud</span></v-card-title
                >
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.nombre"
                        label="Deudor"
                        value="editedItem.nombre"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.fecha_solicitud"
                            label="Fecha Comprobación"
                            append-icon="mdi-calendar"
                            :disabled="
                              editedItem.id_tipo_archivo_solicitud === '1'
                            "
                            v-on="on"
                            :filled="
                              editedItem.id_tipo_archivo_solicitud === '1'
                            "
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.fecha_solicitud"
                          no-title
                          @input="menu2 = false"
                          :disabled="
                            editedItem.id_tipo_archivo_solicitud === '1'
                          "
                          :max="new Date().toISOString().slice(0, 10)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.total"
                        label="Total"
                        value="editedItem.total"
                        :filled="editedItem.id_tipo_archivo_solicitud == 1"
                        :disabled="editedItem.id_tipo_archivo_solicitud == 1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        :items="divisas"
                        item-value="id_divisa"
                        item-text="divisa"
                        v-model="editedItem.id_divisa"
                        value="editedItem.id_divisa"
                        label="Divisa"
                        :filled="editedItem.id_tipo_archivo_solicitud == 1"
                        :disabled="editedItem.id_tipo_archivo_solicitud == 1"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedItem.id_cuenta"
                        :items="cuentas"
                        value="editedItem.id_cuenta"
                        item-value="id_cuenta"
                        item-text="nombre_cuenta"
                        label="Tipo Gasto"
                        @change="mostrar_descripciones_propina"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="editedItem.id_forma_solicitud === '2'"
                    >
                      <v-text-field
                        v-model="editedItem.monto_cambio"
                        label="Tipo Cambio"
                        value="editedItem.monto_cambio"
                        :filled="editedItem.id_tipo_archivo_solicitud == 1"
                        :disabled="editedItem.id_tipo_archivo_solicitud == 1"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-model="editedItem.descripcion_propina"
                      v-if="requiere_anexos"
                    >
                      <v-text-field
                        v-model="editedItem.propina"
                        label="Propina"
                        value="editedItem.propina"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" v-if="descripciones_propina">
                      <v-textarea
                        v-model="editedItem.descripcion_propina"
                        label="Descripción de propina"
                        value="editedItem.descripcion_propina"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="descripciones_propina">
                      <v-textarea
                        v-model="editedItem.comensales_propina"
                        label="Comensales de propina"
                        value="editedItem.comensales_propina"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row v-if="requiere_descripcion">
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="editedItem.comentarios"
                        label="Comentarios"
                        value="editedItem.descripcion"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="editedItem.descripcion"
                        label="Descripción"
                        value="editedItem.descripcion"
                        :filled="editedItem.id_tipo_archivo_solicitud == 1"
                        :disabled="editedItem.id_tipo_archivo_solicitud == 1"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h6 style="margin-bottom: 20px">Anexos</h6>
                      <v-data-table
                        :headers="fileHeaders"
                        :items="fileItems"
                        class="elevation-1"
                      >
                        <template v-slot:item.actionsFile="{ item }">
                          <v-icon
                            small
                            class="mr-1"
                            @click="download_file(item)"
                            >mdi-download</v-icon
                          >
                          <v-icon
                            small
                            class="mr-1"
                            @click="delete_file(item)"
                            v-if="
                              editedItem.id_forma_solicitud === '1' &&
                              item.id_tipo_archivo !== '1'
                            "
                            >mdi-delete</v-icon
                          >
                          <v-icon
                            small
                            class="mr-1"
                            @click="delete_file(item)"
                            v-if="editedItem.id_forma_solicitud === '2'"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedItem.id_forma_solicitud === '2'">
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        v-model="editedItem.comprobantes"
                        placeholder="Agregar comprobantes"
                        label="Comprobantes"
                        multiple
                        prepend-icon="mdi-paperclip"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip small label color="primary">{{
                            text
                          }}</v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row v-if="requiere_anexos">
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        v-model="editedItem.anexos"
                        placeholder="Agregar anexos"
                        label="Anexos"
                        multiple
                        prepend-icon="mdi-paperclip"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip small label color="primary">{{
                            text
                          }}</v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save()"
                    :disabled="is_waiting"
                  >
                    <label v-if="!is_waiting">Guardar</label>
                    <v-progress-circular
                      small
                      indeterminate
                      color="primary"
                      v-if="is_waiting"
                      :size="20"
                    ></v-progress-circular>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-row justify="center">
              <v-dialog v-model="dialogD" persistent max-width="40%">
                <v-card>
                  <v-card-title class="headline">
                    Eliminar solicitud
                  </v-card-title>
                  <v-card-text
                    >¿ Estás seguro de eliminar esta solicitud ?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogD = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="borrar"
                      :disabled="is_waiting"
                      ><label v-if="!is_waiting">Confirmar</label>
                      <v-progress-circular
                        small
                        indeterminate
                        color="primary"
                        v-if="is_waiting"
                        :size="20"
                      ></v-progress-circular
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog v-model="dialogEnvio" persistent max-width="590">
                <v-card>
                  <v-card-title class="headline">
                    Enviar solicitudes
                  </v-card-title>
                  <v-card-text>
                    ¿ Estás seguro de enviar las solicitudes a autorización ?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogEnvio = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="EnviarAll"
                      :disabled="is_waiting"
                    >
                      <label v-if="!is_waiting">Confirmar</label>
                      <v-progress-circular
                        small
                        indeterminate
                        color="primary"
                        v-if="is_waiting"
                        :size="20"
                      ></v-progress-circular>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog v-model="dialogAddGrupo" max-width="590">
                <v-card>
                  <v-card-title class="headline">
                    Agregar a grupo de comprobantes
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="12">
                          <v-select
                            v-model="grupoSelected"
                            :items="grupos"
                            item-text="grupo"
                            item-value="idgrupo"
                            label="Grupos de comprobantes"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogAddGrupo = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="AgregarG"
                      :disabled="is_waiting"
                    >
                      <label v-if="!is_waiting">Confirmar</label>
                      <v-progress-circular
                        small
                        indeterminate
                        color="primary"
                        v-if="is_waiting"
                        :size="20"
                      ></v-progress-circular>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <div class="text-right" style="margin-top: 35px">
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                @click="dialog_agregar_solicitud_grupo = true"
                ><v-icon left>mdi-plus</v-icon> Agregar solicitudes a grupo
              </v-btn>
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                @click="dialogEnvio = true"
                ><v-icon left>mdi-send</v-icon> Enviar
              </v-btn>
            </div>          
            <v-alert
              type="success"
              :value="alert2"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Solicitud eliminada con exito.</v-alert
            >
            <v-alert
              type="success"
              :value="alert3"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Se agregaron las solicitudes al grupo de gasto
              seleccionado.</v-alert
            >
            <v-alert
              type="success"
              :value="alert4"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Se enviaron las solicitudes a autorización.</v-alert
            >
            <v-card-title style="margin-top40px">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          v-model="grupos_selected"
          :headers="headers_grupos"
          :items="grupos"
          :search="search_grupos"
          item-key="id_grupo"
          sort-by="fecha_creacion"
          show-select
          class="elevation-1"
        >
          <template v-slot:top>
            <v-row justify="center"></v-row>
            <div class="text-right" style="margin-top: 35px">
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                @click="show_form_group"
                ><v-icon left>mdi-plus</v-icon> Agregar un nuevo grupo
              </v-btn>
              <v-btn
                class="ma-2"
                tile
                outlined
                color="primary"
                @click="dialog_envio_grupo = true"
                ><v-icon left>mdi-send</v-icon> Enviar</v-btn
              >
            </div>
            <v-alert
              type="success"
              :value="alert6"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Se enviaron los grupos a autorización.</v-alert
            >
            <v-alert
              type="success"
              :value="alert7"
              close-text="Cerrar"
              dismissible
              style="margin-top: 40px"
              >Grupo eliminado correctamente.</v-alert
            >
            <v-card-title style="margin-top40px">
              <v-text-field
                v-model="search_grupos"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small @click="get_details_group(item)"> mdi-eye</v-icon>
            <v-icon small @click="delete_group(item)"> mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="dialog_envio_grupo" persistent max-width="590">
      <v-card>
        <v-card-title class="headline"> Enviar Grupos </v-card-title>
        <v-alert
          type="error"
          :value="alert8"
          close-text="Cerrar"
          dismissible
          style="margin-top: 40px"
          >No se pueden enviar las solicitudes porque debe al menos tener 1
          solicitud en todos los grupos y debe seleccionarse al menos 1
          grupo.</v-alert
        >
        <v-card-text
          >¿ Estás seguro de enviar los grupos seleccionados a autorización
          ?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_envio_grupo = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="enviar_grupo"
            :disabled="is_waiting"
          >
            <label v-if="!is_waiting">Confirmar</label>
            <v-progress-circular
              small
              indeterminate
              color="primary"
              v-if="is_waiting"
              :size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_agregar_solicitud_grupo"
      persistent
      max-width="590"
    >
      <v-card>
        <v-card-title class="headline">
          Agregar solicitudes a un grupo
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="id_grupo_agregar"
            :items="grupos"
            item-value="id_grupo"
            item-text="nombre"
            label="Grupo"
            :rules="[(v) => !!v || 'Seleccione una cuenta']"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog_agregar_solicitud_grupo = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="agregar_solicitudes_grupos"
            :disabled="is_waiting"
          >
            <label v-if="!is_waiting">Confirmar</label>
            <v-progress-circular
              small
              indeterminate
              color="primary"
              v-if="is_waiting"
              :size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_eliminar_solicitudes_grupo"
      persistent
      max-width="590"
    >
      <v-card>
        <v-card-title class="headline">
          Eliminar solicitudes de un grupo
        </v-card-title>
        <v-card-text
          >¿Estas seguro de eliminar estas solicitudes de este
          grupo?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog_eliminar_solicitudes_grupo = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="eliminar_solicitudes_grupos"
            :disabled="is_waiting"
          >
            <label v-if="!is_waiting">Confirmar</label>
            <v-progress-circular
              small
              indeterminate
              color="primary"
              v-if="is_waiting"
              :size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_eliminar_grupo" width="590">
      <v-card>
        <v-card-title class="headline"> Eliminar Grupo </v-card-title>
        <v-card-text
          >¿Estas seguro de eliminar este grupo? Todas las solicitudes en el se
          eliminaran.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog_eliminar_grupo = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="eliminar_grupo"
            :disabled="is_waiting"
          >
            <label v-if="!is_waiting">Confirmar</label>
            <v-progress-circular
              small
              indeterminate
              color="primary"
              v-if="is_waiting"
              :size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_solicitudes_grupo" width="75%">
      <v-card>
        <v-card-title class="headline"> Solicitudes en Grupo </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selected_solicitudes_grupo"
            :headers="headers"
            :items="solicitudes_grupo"
            :search="search"
            item-key="id_solicitud"
            sort-by="fecha"
            show-select
            class="elevation-1"
          >
            <template v-slot:top>
              <div class="text-right" style="margin-top: 35px">
                <v-btn
                  class="ma-2"
                  tile
                  outlined
                  color="primary"
                  @click="dialog_eliminar_solicitudes_grupo = true"
                >
                  <v-icon left>mdi-delete</v-icon> Eliminar solicitudes del
                  grupo
                </v-btn>
              </div>
              <v-alert
                type="success"
                :value="alert4"
                close-text="Cerrar"
                dismissible
                style="margin-top: 40px"
                >Se eliminaron las solicitudes del grupo de gasto
                seleccionado.</v-alert
              >
              <v-card-title style="margin-top40px">
                <v-text-field
                  v-model="search_solicitudes_grupos"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_group_form" width="60%">
      <v-card>
        <v-card-title
          ><span class="headline">Crear un grupo</span></v-card-title
        >
        <v-card-text>
          <v-form ref="form_grupo">
            <v-row>
              <v-text-field
                v-model="nombre_grupo"
                label="Nombre del grupo"
                :rules="[(v) => !!v || 'Escriba un nombre del grupo']"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-textarea
                v-model="descripcion_grupo"
                label="Descripcion del grupo"
              ></v-textarea>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_group_form = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="create_grupo"
            :disabled="is_waiting"
          >
            <label v-if="!is_waiting">Guardar</label>
            <v-progress-circular
              small
              indeterminate
              color="primary"
              v-if="is_waiting"
              :size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import "babel-polyfill";
import router from "../router/index.js";
//import { v4 as uuidv4 } from "uuid";

export default {
  name: "SolicitudComprobacion",
  data: () => ({
    search: "",
    search_grupos: "",
    search_solicitudes_grupos: "",
    menu2: false,
    dialog: false,
    dialogD: false,
    dialogAddGrupo: false,
    dialogEnvio: false,
    alert: false,
    alert2: false,
    alert3: false,
    alert4: false,
    alert6: false,
    alert7: false,
    alert8: false,
    alert9: false,
    errorMsg: "",
    dialog_envio_grupo: false,
    descripciones_propina: false,
    requiere_anexos: false,
    dialog_solicitudes_grupo: false,
    dialog_eliminar_grupo: false,
    dialog_agregar_solicitud_grupo: false,
    dialog_eliminar_solicitudes_grupo: false,
    dialog_group_form: false,
    requiere_descripcion: false,
    alertMsg: "",
    selected: [],
    grupos_selected: [],
    solicitudes_grupo: [],
    selected_solicitudes_grupo: [],
    id_grupo_agregar: "",
    nombre_grupo: "",
    descripcion_grupo: "",
    grupo_selected: [],
    anexos: [],
    deudor: "",
    id_deudor: "",
    headers: [
      { text: "Fecha", value: "fecha_modified", sortable: true, width: "10%" },
      { text: "Cuenta", value: "nombre_cuenta", width: "10%" },
      { text: "Tipo", value: "tipo_solicitud", width: "10%" },
      { text: "Total", value: "total_edited", width: "10%" },
      { text: "Divisa", value: "divisa", width: "10%" },
      {
        text: "Descripcion",
        value: "descripcion",
        sortable: true,
        width: "40%",
      },
      { text: "Acciones", value: "actions", sortable: false, width: "10%" },
    ],
    headers_grupos: [
      { text: "Fecha", value: "fecha_modified", sortable: true },
      { text: "Nombre grupo", value: "nombre" },
      { text: "Descripcion grupo", value: "descripcion" },
      {
        text: "Monto total",
        type: "numeric-comma",
        targets: 3,
        value: "monto_total",
      },
      { text: "Solicitudes totales", value: "solicitudes_totales" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      IdSolicitud: "",
      Documentos: "",
      Deudor: "",
      idconcepto: "",
      Estado: "",
      Tipo: "",
      Cuenta: "",
      idcuenta: "",
      importe: "",
      Descripcion: "",
      FechaComprobacion: "",
    },
    defaultItem: {
      idconcepto: "",
      Estado: "",
      Documentos: "",
      Tipo: "",
      Cuenta: "",
      importe: "",
      Descripcion: "",
      FechaComprobacion: "",
    },

    postBody: "",
    errors: [],
    grupos: [],
    grupoSelected: "",
    idGrupo: null,
    gruposAll: [],
    imagenes: [],
    cuentas: [],
    selected_grupo: [],
    tipo: ["Comprobación", "Anticipo"],
    estado: ["Pendiente", "Actualizado", "Cancelado"],
    solicitudes: [],
    arr: [],
    nombres: [],
    fileHeaders: [
      { text: "Archivo", value: "nombre_archivo" },
      { text: "Tipo de Archivo", value: "tipo_archivo" },
      { text: "Acciones", value: "actionsFile", sortable: false },
    ],
    fileItems: [],
    empleados: [],
    readonlySelect: false,
    files: null,
    divisas: [],
    is_waiting: false,
    solicitud_raw: {
      id_solicitud: "",
      id_deudor: "",
      id_divisa: "",
      id_cuenta: "",
      subtotal: "",
      iva: "",
      total: "",
      descripcion: "",
      monto_cambio: "",
      descripcion_propina: "",
      comensales_propina: "",
      propina: "",
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Actualizar solicitud";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    //Config for axios
    axios.defaults.headers.common["access-token"] = this.$store.state.token;
    axios.interceptors.response.use(function (response) {
      if (response.data.message == "Token inválida") {
        router.push({ name: "login", params: { errorToken: "true" } });
      } else {
        return response;
      }
    });
    //End config for axios
    this.getSolicitudes();
    this.Dates();
    this.get_conceptos();
    this.get_browser();
    this.get_cuentas();
    this.get_divisas();
    this.getGasto();
    this.get_grupos();
    this.get_deudor();
    //this.getEmpleados();
  },
  methods: {
    get_divisas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/divisas"
        )
        .then((res) => {
          this.divisas = res.data;
        });
    },
    get_grupos() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupos/pendientes/todos"
        )
        .then((res) => {
          this.grupos = res.data;
        });
    },
    get_conceptos() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/conceptos"
        )
        .then((res) => {
          this.conceptos = res.data;
        });
    },
    get_cuentas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/cuentas"
        )
        .then((res) => {
          this.cuentas = res.data;
        });
    },
    getEmpleados: async function () {
      axios
        .get(
          'https://"+process.env.VUE_APP_URL+":3000/select/empleados/comprobacion/' +
            this.$store.state.user.id_puesto
        )
        .then((response) => {
          this.empleados = response.data;
          if (response.data.length <= 1) {
            this.readonlySelect = true;
          }
        });
    },
    show_form_group() {
      this.dialog_group_form = true;
    },
    create_grupo() {
      if (this.$refs.form_grupo.validate()) {
        this.is_waiting = true;
        var grupo = [
          {
            nombre_grupo: this.nombre_grupo,
            descripcion_grupo: this.descripcion_grupo,
            id_deudor: this.id_deudor,
          },
        ];
        axios
          .post(
            "https://" + process.env.VUE_APP_URL + ":3000/gastos/api/v1/grupos",
            grupo
          )
          .then(() => {
            this.get_grupos();
            this.is_waiting = false;
            this.dialog_group_form = false;
          });
      }
    },
    get_deudor() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/usuarios/" +
            this.$store.state.token
        )
        .then((res) => {
          this.deudor = res.data.nombre;
          this.id_deudor = res.data.id_user;
        });
    },
    getSolicitudes() {
      let status = "4";
      axios
        .get("https://" + process.env.VUE_APP_URL + ":3000/solicitud/" + status)
        .then((res) => {
          this.solicitudes = res.data;
        });
    },
    get_details_group(item) {
      this.selected_grupo = item;
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/grupo/" +
            item.id_grupo
        )
        .then((res) => {
          this.solicitudes_grupo = res.data;
          this.dialog_solicitudes_grupo = true;
        });
    },
    delete_group(item) {
      this.grupo_selected = item;
      this.dialog_eliminar_grupo = true;
    },
    eliminar_grupo() {
      this.is_waiting = true;
      axios
        .delete(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupo/" +
            this.grupo_selected.id_grupo
        )
        .then(() => {
          this.alert7 = true;
          this.dialog_eliminar_grupo = false;
          this.getSolicitudes();
          this.get_grupos();
          this.is_waiting = false;
        });
    },
   async  agregar_solicitudes_grupos() {
      this.is_waiting = false;
      var req = { id_grupo: this.id_grupo_agregar, solicitudes: this.selected };
      await axios
        .post(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/grupo/agregar",
          req
        )
        
        this.alert3 = true;
        this.getSolicitudes();
        this.get_grupos();
        this.is_waiting = false;
        this.dialog_agregar_solicitud_grupo = false;
        
    },
    eliminar_solicitudes_grupos() {
      this.is_waiting = true;
      var req = { solicitudes: this.selected_solicitudes_grupo };
      axios
        .post(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/grupo/eliminar",
          req
        )
        .then(() => {
          this.alert5 = true;
          this.getSolicitudes();
          this.get_grupos();
          this.get_details_group(this.selected_grupo);
          this.is_waiting = false;
          this.dialog_eliminar_solicitudes_grupo = false;
        });
    },
    get_browser() {
      let ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: "IE", version: tem[1] || "" };
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
          return { name: "Opera", version: tem[1] };
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
      }
      return {
        name: M[0],
        version: M[1],
      };
    },

    enviar_grupo() {

      try {
        this.is_waiting = true;
      this.alert8 = false;
      this.alert6 = false;
      var validate = this.revisar_grupos();
      if (validate) {
        let browser = this.get_browser();
        var req = {
          grupos: this.grupos_selected,
          explorador: navigator.userAgent,
          deudor: { id: this.id_deudor, nombre: this.deudor },
          navigator: browser,
        };
        axios
          .post(
            "https://" +
              process.env.VUE_APP_URL +
              ":3000/gastos/api/v1/grupos/enviar",
            req
          )
          .then(() => {
            this.dialog_envio_grupo = false;
            this.alert6 = true;
            this.getSolicitudes();
            this.get_grupos();
            this.is_waiting = false;
          });
      } else {
        this.alert8 = true;
        this.is_waiting = false;
      }  
      } catch (error) {
        this.is_waiting=false
        this.alert9=true
        this.errorMsg="Ocurrio un Error."
      }
      
    },
    revisar_grupos() {
      var is_correct = true;
      if (this.grupos_selected.length === 0) {
        is_correct = false;
      }
      this.grupos_selected.forEach((grupo) => {
        var solicitudes_totales = parseInt(grupo.solicitudes_totales);
        if (solicitudes_totales === 0) {
          is_correct = false;
        }
      });
      return is_correct;
    },
    getGrupos() {
      let status = "4";
      axios
        .get("https://" + process.env.VUE_APP_URL + ":3000/grupos/" + status)
        .then((res) => {
          res.data.forEach((element) => {
            this.grupos.push(element.nombre);
          });
          res.data.forEach((element) => {
            this.gruposAll.push(element.nombre + "|" + element.id);
          });
        });
    },
    getCuenta() {
      var idg = this.editedItem.idconcepto;
      axios
        .get(
          "https://" + process.env.VUE_APP_URL + ":3000/cuentasgastos/" + idg
        )
        .then((res) => {
          this.cuentas = res.data;
        });
    },
    getGasto() {
      axios
        .get("https://" + process.env.VUE_APP_URL + ":3000/gastos")
        .then((res) => {
          this.gastos = res.data;
        });
    },
    getImg() {
      let imagesd = this.editedItem.Documentos;
      imagesd = encodeURI(imagesd);
      axios.get(
        "https://" + process.env.VUE_APP_URL + ":3000/imag?url=" + imagesd
      );
    },
    editItem(item) {
      try {
        this.editedIndex = this.desserts.indexOf(item);

      item.id_cuenta = parseInt(item.id_cuenta);
      item.id_divisa = parseInt(item.id_divisa);
      item.fecha_solicitud = item.fecha_solicitud.substr(0, 10);
      this.editedItem = Object.assign({}, item);
      this.editedItem.descripcion_propina =
        this.editedItem.descripcion_propina === "undefined"
          ? null
          : this.editedItem.descripcion_propina;
      this.editedItem.comensales_propina =
        this.editedItem.comensales_propina === "undefined"
          ? null
          : this.editedItem.comensales_propina;
      var obj_selected = this.cuentas.filter((item) => {
        return item.id_cuenta === this.editedItem.id_cuenta;
      });
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripciones_propina = true;
      } else {
        this.descripciones_propina = false;
      }
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.requiere_anexos = true;
      } else {
        this.requiere_anexos = false;
      }
      if (obj_selected[0]["requiere_descripcion"] === true) {
        this.requiere_descripcion = true;
      } else {
        this.requiere_descripcion = false;
      }
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/archivos/" +
            this.editedItem.id_solicitud
        )
        .then((res) => {
          this.fileItems = res.data;
          this.dialog = true;
        });
      } catch (error) {
        this.alert9=true
        this.errorMsg="Ocurrio un Error"
      }

      
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogD = true;
    },
    download_file(item) {
      /*
      axios({
        url:
          "https://" +
          process.env.VUE_APP_URL +
          ":3000/download/" +
          item.id_solicitud +
          "/" +
          item.nombre_archivo,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.nombre_archivo);
        document.body.appendChild(link);
        link.click();
      });
      */
      window.open("https://" +
          process.env.VUE_APP_URL +
          ":3000/open/" +
          item.id_solicitud +
          "/" +
          item.nombre_archivo)
    },
    delete_file(item) {
      try {
        axios
        .post("https://" + process.env.VUE_APP_URL + ":3000/delete/file", item)
        .then((response) => {
          if (response.data.message === "Archivo eliminado") {
            axios
              .get(
                "https://" +
                  process.env.VUE_APP_URL +
                  ":3000/gastos/api/v1/solicitudes/archivos/" +
                  this.editedItem.id_solicitud
              )
              .then((res) => {
                this.fileItems = res.data;
              });
          }
        });  
      } catch (error) {
        this.alert9=true
        this.errorMsg= "Ocurrio un error"
      }

      
    },
    Dates() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    create_array_data(solicitud) {
      this.solicitud_raw["id_solicitud"] = solicitud.id_solicitud;
      this.solicitud_raw["id_deudor"] = solicitud.id_deudor;
      this.solicitud_raw["id_divisa"] = solicitud.id_divisa;
      this.solicitud_raw["id_cuenta"] = solicitud.id_cuenta;
      this.solicitud_raw["subtotal"] = solicitud.subtotal;
      this.solicitud_raw["iva"] = solicitud.iva;
      this.solicitud_raw["total"] = solicitud.total;
      this.solicitud_raw["descripcion"] = solicitud.descripcion;
      this.solicitud_raw["monto_cambio"] = solicitud.monto_cambio;
      this.solicitud_raw["descripcion_propina"] = solicitud.descripcion_propina;
      this.solicitud_raw["comensales_propina"] = solicitud.comensales_propina;
      this.solicitud_raw["propina"] = solicitud.propina;
      this.solicitud_raw["fecha_solicitud"] = solicitud.fecha_solicitud;
      this.solicitud_raw["comentarios"] = solicitud.comentarios;
    },
    async save() {

      try {
        this.is_waiting = true;
      this.alert = false;
      if (this.requiere_anexos) {
        this.editedItem.propina = parseFloat(
          parseFloat(this.editedItem.total) * 0.1
        ).toFixed(2);
      }
      this.create_array_data(this.editedItem);
      await axios
        .put(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes",
          { solicitud: JSON.stringify(this.solicitud_raw) }
        )
        
          var form_file = new FormData();
          form_file.append("id_solicitud", this.editedItem.id_solicitud);
          if (this.editedItem.comprobantes !== undefined) {
            this.editedItem.comprobantes.forEach((file) =>
              form_file.append("comprobantes", file)
            );
          }
          if (this.editedItem.anexos !== undefined) {
            this.editedItem.anexos.forEach((file) =>
              form_file.append("anexos", file)
            );
          }
          if (
            this.editedItem.comprobantes !== undefined ||
            this.editedItem.anexos !== undefined
          ) {
            axios
              .post(
                "https://" +
                  process.env.VUE_APP_URL +
                  ":3000/gastos/api/v1/solicitudes/archivos",
                form_file
              )
              .then(() => {
                this.alert = true;
                this.getSolicitudes();
                this.is_waiting = false;
                this.dialog = false;
              }).catch( () => {
                this.is_waiting = false;
                
              });
          } else {
            this.alert = true;
            this.getSolicitudes();
            this.is_waiting = false;
            this.dialog = false;
          }
       
      } catch (error) {
        this.is_waiting = false;
        this.dialog = false;
        this.dialog_solicitudes_grupo=false
        this.errorMsg = "Error al actualizar";
          this.alert9 = true;
      }
     
    },
    borrar() {
      try {
        this.is_waiting = true;
      let IdSolicitud = this.editedItem.id_solicitud;
      axios
        .delete(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/Deletesolicitud/" +
            IdSolicitud
        )
        .then(() => {
          this.alert2 = true;
          this.getSolicitudes();
          this.close();
          this.get_grupos();
          if (this.dialog_solicitudes_grupo === true) {
            this.get_details_group(this.selected_grupo);
          }
          this.is_waiting = false;
          this.dialogD = false;
        });
      } catch (error) {
          this.is_waiting = false;
          this.dialogD = false;
          this.alert9= true
          this.errorMsg= "Ocurrio un error"

      }
      
    },
    AgregarG() {

      try {
        this.is_waiting = true;
      this.dialogAddGrupo = false;
      var r = [];
      for (var i = 0; i < this.gruposAll.length; i++) {
        var arr = this.gruposAll[i].split("|");
        r.push(arr[0]);
        r.push(arr[1]);
      }
      for (var j = 0; j < r.length; j++) {
        if (r[j] == this.grupoSelected) {
          var idR = r[j + 1];
        }
      }
      this.idGrupo = idR;
      let solicitudes = this.selected;

      idR = idR.replace('"', "'");
      var c = {
        idGrupo: idR,
        solicitudes: solicitudes,
      };
      axios
        .put(
          "https://" + process.env.VUE_APP_URL + ":3000/addGruposolicitud",
          c
        )
        .then((res) => {
          this.alertMsg = res.data.message;
          this.alert3 = true;
          this.getSolicitudes();
          this.is_waiting = false;
          this.close();
        });
      } catch (error) {
        this.is_waiting = false;
          this.close()
          this.alert9= true
          this.errorMsg= "Ocurrio un error"
      }

      
    },
    mostrar_descripciones_propina() {
      var obj_selected = this.cuentas.filter((obj) => {
        return obj.id_cuenta === this.editedItem.id_cuenta;
      });
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripciones_propina = true;
      } else {
        this.descripciones_propina = false;
      }
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.requiere_anexos = true;
      } else {
        this.requiere_anexos = false;
      }
    },
    EnviarAll() {
      try {
        this.is_waiting = true;
      this.dialogEnvio = false;
      let solicitudes = this.selected;
      let browser = this.get_browser();
      var c = {
        solicitudes: solicitudes,
        explorador: navigator.userAgent,
        deudor: { id: this.id_deudor, nombre: this.deudor },
        navigator: browser,
      };
      axios
        .put("https://" + process.env.VUE_APP_URL + ":3000/enviaAutoriza", c)
        .then((res) => {
          this.alertMsg = res.data.message;
          this.alert4 = true;
          this.getSolicitudes();
          this.is_waiting = false;
          this.close();
        });
      } catch (error) {
          this.getSolicitudes();
          this.is_waiting = false;
          this.close();
          this.alert9=true
          this.errorMsg= "Ocurrio un Error"
      }
      
    },
  },
};
</script>
